import { render, staticRenderFns } from "./ToccaVinoBasket.vue?vue&type=template&id=366a225e&"
import script from "./ToccaVinoBasket.vue?vue&type=script&lang=js&"
export * from "./ToccaVinoBasket.vue?vue&type=script&lang=js&"
import style0 from "./ToccaVinoBasket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports